import React, { useEffect } from "react";

const DistantSalesAgreement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Mesafeli Satış Sözleşmesi</h1>
      <p className="mb-4">
        İşbu Mesafeli Satış Sözleşmesi (“Sözleşme”); aşağıda belirtilen taraflar
        arasında, aşağıda belirtilen hüküm ve şartlar çerçevesinde elektronik
        ortamda kurulmuştur.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Taraflar</h2>
      <p className="mb-4">
        <strong>Satıcı:</strong> HALISAHABUL
        <br /> Adres: Afyonkarahisar/Dinar İtfaiye mahallesi Yeniyol Caddesi
        <br /> Telefon: 0 538 237 1255
        <br /> E-posta: destek@halisahabul.com
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Konu</h2>
      <p className="mb-4">
        İşbu Sözleşme, Alıcı'nın Satıcı'ya ait HALISAHABUL internet sitesi
        üzerinden elektronik ortamda siparişini verdiği aşağıda belirtilen
        ürünün satışı ve teslimi ile ilgili olarak tarafların hak ve
        yükümlülüklerini düzenler.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Ürün ve Hizmet Bilgileri
      </h2>
      <p className="mb-4">
        Ürün/hizmet türü, miktarı, markası/modeli, rengi ve satış bedeli sipariş
        aşamasında belirtilen gibidir.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Teslimat Koşulları</h2>
      <p className="mb-4">
        Platformumuzda herhangi bir fiziksel ürün teslimatı yapılmamaktadır.
        Kullanıcılar, yalnızca halısaha rezervasyonu yapabilmektedir. Yapılan
        rezervasyonlar, ilgili sahaların belirlediği koşullara tabidir ve
        kullanıcılar, rezervasyon saatinde sahada bulunmalıdır.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Cayma Hakkı</h2>
      <p className="mb-4">
        Eğer saha iptal hakkı tanıyorsa, bu bilgiyi saha profilinde görebilir ve
        cayma hakkınızı kullanabilirsiniz.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Uyuşmazlıkların Çözümü
      </h2>
      <p className="mb-4">
        İşbu Sözleşme'den doğabilecek ihtilaflarda, Tüketici Hakem Heyetleri ve
        Tüketici Mahkemeleri yetkilidir.
      </p>
    </div>
  );
};

export default DistantSalesAgreement;
